/**
 * StatusTag: the one Tag for any status in the admin portals. One status -> colour map (green done, red failed,
 * blue in progress, purple needs attention, gray neutral and every unknown status), default Tag size.
 *
 * Props: `status` (the status code, picks the colour), `children` (the translated label). `statusTagType(status)`
 * (from ./statusTagType, also exported from the package) gives the colour alone.
 */
import { Tag } from '@carbon/react';
import type { ReactNode } from 'react';
import { statusTagType } from './statusTagType';

export function StatusTag({ status, children }: { status: string; children: ReactNode }) {
  return <Tag type={statusTagType(status)}>{children}</Tag>;
}
